'use strict';

module.exports = {
    template: require('html-loader!./cardsLoading.html')
};



// WEBPACK FOOTER //
// ./widgets/components/cardsLoading.js